import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";

type HandlerType = Handler<{
    isOpen?: boolean;
}>;

export const DispatchSetDesktopFlyoutDrawerIsOpen: HandlerType = ({ dispatch, parameter: { isOpen } }) => {
    dispatch({
        type: "Components/DesktopFlyoutDrawer/SetDesktopFlyoutDrawerIsOpen",
        isOpen,
    } as any);
};

export const chain = [DispatchSetDesktopFlyoutDrawerIsOpen];

const setDesktopFlyoutDrawerIsOpen = createHandlerChainRunner(chain, "SetDesktopFlyoutDrawerIsOpen");
export default setDesktopFlyoutDrawerIsOpen;
